<template>
    <div class="d-flex flex-column z-40 fixed top-0 left-0 right-0">
        <div class="d-flex justify-content-between px-3 py-2 md:px-8 bg-prime-color">
            <!-- left side -->
            <a href="/" class="header-left-side p-0">
                <img src="@/assets/img/logo-white.png" class="w-12" alt="Logo">
                <div class="d-flex flex-column text-white">
                    <h2 class="mb-0 text-xl md:text-2xl">Đại học Huế</h2>
                    <h1 class="mb-0 text-lg md:text-xl">Khoa Kỹ Thuật và Công Nghệ</h1>
                </div>
            </a>
            <!-- right side -->
            <div class="header-right-side-mobile pr-0">
                <a target="_blank" href="https://dkxt.hueuni.edu.vn/" class="btn btn-light d-none d-sm-block mr-4 mr-md-2" style="border-radius: 30px; color: #7D8600;">
                    <b>Xét tuyển ngay!</b>
                </a>
                <button class="btn btn-outline-light d-none d-md-block mr-4 mr-md-0" style="border-radius: 30px;" @click="redirect('login')">
                    <b>Đăng nhập</b>
                </button>
                <div class="open-menu d-md-none" @click="isShowMenu = true">
                    <span class="line-1"></span>
                    <span class="line-2"></span>
                    <span class="line-3"></span>
                </div>
                <vue-page-transition name="fade">
                    <div v-if="isShowMenu" class="mobile-menu" @click="isShowMenu = false">
                        <div class="close-btn pr-3 pt-4">
                            <svg v-show="isShowMenu" @click="isShowMenu=false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/>
                            </svg>
                        </div>
                        <div class="sub-menu">
                            <div
                                v-for="(item, index) in menu" :key="index"
                                @click="redirect(item.name)"
                                class="d-flex justify-content-center menu-text" 
                                style="gap: 4px; align-items: center;">
                                <svg :class="{'d-none' : item.name == pageName}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path></svg>
                                <h6 :class="{'text-prime-color' : item.name == pageName}" class="text-center"> 
                                    {{ item.title }}
                                </h6>
                                <svg :class="{'d-none' : item.name == pageName}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m4.431 12.822 13 9A1 1 0 0 0 19 21V3a1 1 0 0 0-1.569-.823l-13 9a1.003 1.003 0 0 0 0 1.645z"></path></svg>
                            </div>
                            <a target="_blank" href="https://dkxt.hueuni.edu.vn/" class="text-center">
                                <button class="btn btn-lg btn-outline-success d-md-none rounded-full">Xét tuyển ngay!</button>
                            </a>
                        </div>
                    </div>
                </vue-page-transition>
            </div>
        </div>
        <div class="lg:justify-around overflow-y-auto bg-white gap-2 py-2 px-2 d-none d-md-flex shadow-md shadow-[#00000034]">
            <div
                v-for="(item, index) in menu" :key="index"
                @click="redirect(item.name)"
                :class="{'d-none' : item.name=='login'}"
            >
                <h6 
                    :class="{'text-prime-color' : item.name==pageName}" 
                    class="w-max text-black text-base text-center mb-0 md:px-2 lg:px-0 text-clip uppercase font-sans font-semibold cursor-pointer"
                >
                    {{ item.title }}
                </h6>
            </div>
        </div>
    </div>
</template>
    
<script>

export default {
    data() {
        return {
            isShowMenu: false,
            menu: [
                {name: 'home', title: 'Trang chủ'},
                {name: 'about', title: 'Giới thiệu'},
                {name: 'admission', title: 'Tuyển sinh'},
                {name: 'training', title: 'Đào tạo'},
                {name: 'student-life', title: 'Sinh viên'},
                {name: 'cooperation', title: 'Hợp tác'},
                {name: 'news', title: 'Bản tin'},
                {name: 'recruitment', title: 'Tuyển dụng'},
                {name: 'contact', title: 'Liên hệ'},
                {name: 'login', title: 'Đăng nhập'},
            ],
        }
    },
    methods: {
        redirect(page) {
            this.isShowMenu = false
            if (this.pageName != page) {
                if(page == 'login') {
                    this.$router.push({name: 'auth'})
                } else {
                    this.$router.push({name: 'user.' + page})
                }
            }
        }
    },
    created() {
    },
    computed: {
        pageName() {
            return this.$route.name.split('.')[1]
        }
    },
};
</script>
    
<style lang="scss" scoped>
.header-left-side {
    display: flex;
    gap: 4px;
    align-items: center;
    padding: 0px 8px;
    cursor: pointer;
    img {
        object-fit: contain;
        object-position: center;
    }
}
.header-right-side-mobile {
    display: flex;
    align-items: center;
    cursor: pointer;
    div.open-menu {
        width: 35px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        span {
            background-color: white;
            height: 3px;
            border-radius: 10px;
            width: 30px;
            transition: all 350ms;
            margin-right: 5px;
        }
        span.line-1 {
            width: 35px;
            margin-right: 0px;
        }
        &:hover {
            span.line-1 {
                width: 30px;
                margin-left: 5px;
            }
            span.line-2 {
                margin-left: 5px;
            }
            span.line-3 {
                width: 35px;
            }
        }
    }
    .mobile-menu {
        position: fixed;
        top: 0;
        right: 0;
        height: 100vh;
        width: 100vw;
        background-color: #fafafa;
        box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.428);
        div.sub-menu {
            background: transparent;
            display: flex;
            flex-direction: column;
            gap: 24px;
            margin-top: 16px;
            div.menu-text {
                h6 {
                    color: black;
                    font-size: 24px;
                    margin-bottom: 0;
                }
                svg {
                    display: none;
                    width: 12px;
                    fill: var(--orange500);
                }
                &:hover {
                    h6 {
                        color: var(--orange500)
                    }
                    svg {
                        display: block;
                    }
                }
            }
        }
        .close-btn {
            padding: 4px 10px;
            display: flex;
            justify-content: end;
            align-self: center;
            height: 58px;
            svg {
                width: 30px;
                fill: var(--orange300);
            }
        }
    }
}
@media screen and (min-width : 576px) {
    .header-right-side-mobile {
        .mobile-menu {
            width: 40vw;
        }
    }
}

@media screen and (min-width: 768px) {
    .header-right-side-mobile {
        .mobile-menu {
            width: 30vw;
        }
    }
}

@media screen and (min-width: 992px) {
    .header-right-side-mobile {
        .mobile-menu {
            width: 25vw;
        }
    }
}
</style>
    